import React, { useState, useEffect } from 'react';
import { staffClient } from 'clients/staff';
import Loading from 'ui/Loading';
import Unauthorized from 'pages/Unauthorized';

interface ProtectedRouteProps {
    children: React.ReactNode;
    requiredType?: 'MASTER' | 'STAFF';
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    children,
    requiredType = 'MASTER'
}) => {
    const [loading, setLoading] = useState(true);
    const [authorized, setAuthorized] = useState(false);

    useEffect(() => {
        checkAuth();
    }, []);

    const checkAuth = async () => {
        try {
            const ret = await staffClient.get('/auth/my-info');
            const userType = ret.data.token?.type;

            if (requiredType === 'MASTER') {
                setAuthorized(userType === 'MASTER');
            } else {
                setAuthorized(true);
            }
        } catch (e) {
            console.error('[ProtectedRoute] Auth check failed:', e);
            setAuthorized(false);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Loading text="권한 확인 중..." />;
    }

    if (!authorized) {
        return <Unauthorized />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
